const CHECKBOX_FALSE_VALUE = "0";

export default CHECKBOX_FALSE_VALUE;
